import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, Observable, of, tap } from "rxjs";
import { environment } from "@env/environment";
import { ApiResponse, ApiRequest } from "./interfaces/api-status";
import { StorageService } from "@services/storage.service";
import { Router } from "@angular/router";



@Injectable({
    providedIn: 'root',
})
export class UserApiService {
    private url = environment.serverUrl;

    private userAvatar$: BehaviorSubject<any>;
    cachedUserAvatar$: Observable<any>;

    constructor(
        private http: HttpClient,
        protected storage: StorageService,
        private router: Router,
    ) {
        this.userAvatar$ = new BehaviorSubject<any>(
            this.storage.get('avatar')
        );
        this.cachedUserAvatar$ = this.userAvatar$.asObservable();
    }


    verifyAddress(eth_address: string): Observable<any> {
        if (!eth_address) {
            return of(new Error('Empty address'))
        }

        return this.http.post<ApiRequest>(this.url + 'defi_nonce', {eth_address}).pipe(
            tap(res => {
                // @ts-ignore
                if (res?.code === 'COINDEPO_LISTING') {
                    this.router.navigate(['/downtime']);
                  }
            })
        )
    }

    authWallet(signature?: any): Observable<any> {
        if (!signature) {
            return of(new Error('Empty address'))
        }

        const ref = localStorage.getItem('ref') ?? '';

        if (signature.jsonrpc) {
            delete signature.jsonrpc;
        }
        if (ref) {
            signature.dref_code = ref;
            localStorage.removeItem('ref')
        }

        return this.http.post<ApiRequest>(this.url + 'defi_login', signature ).pipe()
    }

    setAvatar(avatar: Blob): Observable<ApiResponse> {
        return this.http.post<ApiResponse>('set_avatar', {avatar});
    }

    clearAvatar(): Observable<ApiResponse> {
        return this.http.post<ApiResponse>('set_avatar', {});
    }

    resetUserAvatar() {
        this.userAvatar$.next(null);
        this.storage.set('avatar', null);
    }

    getAvatar(): Observable<ApiResponse> {
        return this.http.post<ApiResponse>('get_avatar', {}).pipe(
            tap((res: any) => {
                const avatar = res.avatar ? res.avatar : null
                this.userAvatar$.next(avatar);
                this.storage.set('avatar', avatar);
            })
        )
    }

    disconnectWallet() {

        return this.http.post('https://pulse.walletconnect.org/e', {
            domain: "localhost",
            eventId: "616e2b9a-5dd2-4b2d-ba02-1dea05a8c274",
            props: {type: "track", event: "DISCONNECT_SUCCESS"},
            timestamp: Math.floor(Date.now() / 1000),
            url: "http://localhost:4201/"
        })
    }
}